// @flow
import React from 'react'
import I18n from 'i18n-react'
import classNames from 'classnames/bind'
import { Link } from 'react-router-dom'
import { getStepUrl } from '../ContainerFunctions'

type NavigationPanelProps = {
  id?: string,
  name?: string,
  step: { index: number },
  steps: Array<{ [key: string]: string }>,
  subProductName: string,
  url: string
}

const NavigationPanel = (props: NavigationPanelProps) => {
  let lastValidStepUrl = '/'
  let prevStepUrl = props.url
  let nextStepUrl = props.url
  let activeStepIndex = props.steps.findIndex((step) => props.url.replace(/\/$/, '') === getStepUrl(props.subProductName, step.key))
  if (activeStepIndex >= 0) {
    prevStepUrl = activeStepIndex > 0 ? getStepUrl(props.subProductName, props.steps[activeStepIndex - 1].key) : '/'
    nextStepUrl = activeStepIndex === props.steps.length - 1 ? nextStepUrl : getStepUrl(props.subProductName, props.steps[activeStepIndex + 1].key)
  }

  return (
    <ul className='nav nav-progressbar text-center bg-active-object'>
      <li className='d-lg-none'>
        <Link to={prevStepUrl}>
          <button
            className='progressbar-mobile-nav prev'
            name='button'
            type='button'
          >
            <span>◤</span>
          </button>
        </Link>
      </li>
      {props.steps.map((step, index) => {
        const classes = {
          'nav-link': true,
          'active': props.url.replace(/\/$/, '') === step.url.replace(/\/$/, ''), // active step
          'done': index < props.step,
        }
        const liClasses = {
          'nav-item': true,
          'current-item': props.url.replace(/\/$/, '') === step.url.replace(/\/$/, '')
        }
        lastValidStepUrl = index > props.step.index ? lastValidStepUrl : step.url
        return (
          <li className={classNames(liClasses)} key={step.key}>
            <Link
              className={classNames(classes)}
              to={lastValidStepUrl}
            >
              {I18n.translate(step.label)}
              {index < props.step.index && <span className='pfp pfp-check'/>}
            </Link>
          </li>
        )
      })}
      <li className='d-lg-none'>
        <Link to={nextStepUrl}>
          <button
            className='progressbar-mobile-nav next'
            type='button'
          >
            <span>◥</span>
          </button>
        </Link>
      </li>
    </ul>
  )
}

NavigationPanel.defaultProps = {
  steps: [],
  step: 0
}

export default NavigationPanel
